var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOvercapacity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_19988)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.992 105.691C249.992 79.0918 232.941 56.5573 209.431 48.9575C206.072 21.3859 183.079 0.000244141 155.263 0.000244141C127.447 0.000244141 133.647 3.44669 124.949 9.36751C116.337 3.44669 105.917 0.000244141 94.7218 0.000244141C66.9057 0.000244141 43.9123 21.3859 40.5537 48.9575C17.0435 56.5573 -0.0078125 79.0918 -0.0078125 105.691C-0.0078125 132.291 25.9137 165.165 57.9495 165.165H193.327C224.76 164.458 249.992 138.123 249.992 105.691Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.519 9.1024C115.907 3.35832 105.745 0.000244141 94.7218 0.000244141C66.9057 0.000244141 43.9123 21.3859 40.5537 48.9575C17.0435 56.5573 -0.0078125 79.0918 -0.0078125 105.691C-0.0078125 132.291 25.9137 165.165 57.9495 165.165H98.6832L124.519 9.1024Z",
    fill: "#C7DDF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.698 144.397H70.8594V152.439H176.698V144.397Z",
    fill: "#0B2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.698 105.249H70.8594V113.291H176.698V105.249Z",
    fill: "#0B2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.527 150.495H65.6989C62.7025 150.495 60.2734 152.987 60.2734 156.062V181.248C60.2734 184.323 62.7025 186.815 65.6989 186.815H181.527C184.524 186.815 186.953 184.323 186.953 181.248V156.062C186.953 152.987 184.524 150.495 181.527 150.495Z",
    fill: "#F2F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.805 150.495L107.035 186.815H65.6989C62.6847 186.815 60.2734 184.341 60.2734 181.248V156.062C60.2734 152.969 62.6847 150.495 65.6989 150.495H112.805Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.203 178.773V158.448H68.1111V178.773H179.203Z",
    fill: "#0B2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.335 168.611C170.335 170.555 168.785 172.146 166.89 172.146C164.995 172.146 163.445 170.555 163.445 168.611C163.445 166.667 164.995 165.076 166.89 165.076C168.785 165.076 170.335 166.667 170.335 168.611Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.614 168.611C155.614 170.29 154.322 171.615 152.686 171.615C151.05 171.615 149.758 170.29 149.758 168.611C149.758 166.932 151.05 165.606 152.686 165.606C154.322 165.606 155.614 166.932 155.614 168.611Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.403 168.611C141.403 170.29 140.111 171.615 138.475 171.615C136.839 171.615 135.547 170.29 135.547 168.611C135.547 166.932 136.839 165.606 138.475 165.606C140.111 165.606 141.403 166.932 141.403 168.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.106 168.611C127.106 170.29 125.814 171.615 124.178 171.615C122.542 171.615 121.25 170.29 121.25 168.611C121.25 166.932 122.542 165.606 124.178 165.606C125.814 165.606 127.106 166.932 127.106 168.611Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.895 168.611C112.895 170.29 111.603 171.615 109.967 171.615C108.331 171.615 107.039 170.29 107.039 168.611C107.039 166.932 108.331 165.606 109.967 165.606C111.603 165.606 112.895 166.932 112.895 168.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.527 110.728H65.6989C62.7025 110.728 60.2734 113.221 60.2734 116.295V141.481C60.2734 144.556 62.7025 147.048 65.6989 147.048H181.527C184.524 147.048 186.953 144.556 186.953 141.481V116.295C186.953 113.221 184.524 110.728 181.527 110.728Z",
    fill: "#F2F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.092 110.728L113.322 147.048H65.6129C62.5988 147.048 60.1875 144.574 60.1875 141.481V116.295C60.1875 113.202 62.5988 110.728 65.6129 110.728H119.092Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.117 139.007V118.681H68.0252V139.007H179.117Z",
    fill: "#0B2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.527 71.4917H65.6989C62.7025 71.4917 60.2734 73.9843 60.2734 77.059V102.245C60.2734 105.319 62.7025 107.812 65.6989 107.812H181.527C184.524 107.812 186.953 105.319 186.953 102.245V77.059C186.953 73.9843 184.524 71.4917 181.527 71.4917Z",
    fill: "#F2F8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.379 71.4917L119.609 107.812H65.6989C62.6847 107.812 60.2734 105.338 60.2734 102.245V77.059C60.2734 73.9661 62.6847 71.4917 65.6989 71.4917H125.379Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.117 99.8587V79.5334H68.0252V99.8587H179.117Z",
    fill: "#0B2032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.335 128.844C170.335 130.788 168.785 132.379 166.89 132.379C164.995 132.379 163.445 130.788 163.445 128.844C163.445 126.9 164.995 125.309 166.89 125.309C168.785 125.309 170.335 126.9 170.335 128.844Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.614 128.844C155.614 130.523 154.322 131.849 152.686 131.849C151.05 131.849 149.758 130.523 149.758 128.844C149.758 127.165 151.05 125.84 152.686 125.84C154.322 125.84 155.614 127.165 155.614 128.844Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.403 128.844C141.403 130.523 140.111 131.849 138.475 131.849C136.839 131.849 135.547 130.523 135.547 128.844C135.547 127.165 136.839 125.84 138.475 125.84C140.111 125.84 141.403 127.165 141.403 128.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.106 128.844C127.106 130.523 125.814 131.849 124.178 131.849C122.542 131.849 121.25 130.523 121.25 128.844C121.25 127.165 122.542 125.84 124.178 125.84C125.814 125.84 127.106 127.165 127.106 128.844Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.895 128.844C112.895 130.523 111.603 131.849 109.967 131.849C108.331 131.849 107.039 130.523 107.039 128.844C107.039 127.165 108.331 125.84 109.967 125.84C111.603 125.84 112.895 127.165 112.895 128.844Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.335 89.6962C170.335 91.6403 168.785 93.231 166.89 93.231C164.995 93.231 163.445 91.6403 163.445 89.6962C163.445 87.752 164.995 86.1614 166.89 86.1614C168.785 86.1614 170.335 87.752 170.335 89.6962Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.614 89.6962C155.614 91.3753 154.322 92.7008 152.686 92.7008C151.05 92.7008 149.758 91.3753 149.758 89.6962C149.758 88.0172 151.05 86.6917 152.686 86.6917C154.322 86.6917 155.614 88.0172 155.614 89.6962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.403 89.6962C141.403 91.3753 140.111 92.7008 138.475 92.7008C136.839 92.7008 135.547 91.3753 135.547 89.6962C135.547 88.0172 136.839 86.6917 138.475 86.6917C140.111 86.6917 141.403 88.0172 141.403 89.6962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.106 89.6962C127.106 91.3753 125.814 92.7008 124.178 92.7008C122.542 92.7008 121.25 91.3753 121.25 89.6962C121.25 88.0172 122.542 86.6917 124.178 86.6917C125.814 86.6917 127.106 88.0172 127.106 89.6962Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.895 89.6962C112.895 91.3753 111.603 92.7008 109.967 92.7008C108.331 92.7008 107.039 91.3753 107.039 89.6962C107.039 88.0172 108.331 86.6917 109.967 86.6917C111.603 86.6917 112.895 88.0172 112.895 89.6962Z",
    fill: "#739CD2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.035 250C130.267 250 134.508 245.648 134.508 240.28C134.508 234.911 130.267 230.559 125.035 230.559C119.804 230.559 115.562 234.911 115.562 240.28C115.562 245.648 119.804 250 125.035 250Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.052 223.489H121.852V227.024H128.052V223.489Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.052 216.773H121.852V220.308H128.052V216.773Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.052 209.969H121.852V213.503H128.052V209.969Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.052 203.164H121.852V206.699H128.052V203.164Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.052 196.448H121.852V199.983H128.052V196.448Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.052 189.643H121.852V193.178H128.052V189.643Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3714 242.931C86.6032 242.931 90.8444 238.579 90.8444 233.21C90.8444 227.841 86.6032 223.489 81.3714 223.489C76.1396 223.489 71.8984 227.841 71.8984 233.21C71.8984 238.579 76.1396 242.931 81.3714 242.931Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4661 216.773H78.2656V220.308H84.4661V216.773Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4661 209.969H78.2656V213.503H84.4661V209.969Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4661 203.164H78.2656V206.699H84.4661V203.164Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4661 196.448H78.2656V199.983H84.4661V196.448Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.4661 189.643H78.2656V193.178H84.4661V189.643Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.606 242.931C173.838 242.931 178.079 238.579 178.079 233.21C178.079 227.841 173.838 223.489 168.606 223.489C163.374 223.489 159.133 227.841 159.133 233.21C159.133 238.579 163.374 242.931 168.606 242.931Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7 216.773H165.5V220.308H171.7V216.773Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7 209.969H165.5V213.503H171.7V209.969Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7 203.164H165.5V206.699H171.7V203.164Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7 196.448H165.5V199.983H171.7V196.448Z",
    fill: "#9DBDE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.7 189.643H165.5V193.178H171.7V189.643Z",
    fill: "#9DBDE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_19988"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvercapacity);
export default __webpack_public_path__ + "static/media/overcapacity.7bd8806639c1f517c927481e39ccfb38.svg";
export { ForwardRef as ReactComponent };